import { createStore } from 'hox';
import { trpcApi } from '@bitbot/api';
import { useCallback, useEffect, useRef, useState } from 'react';
import { networks, NetworkType } from './index';

export type PairList = Awaited<
  ReturnType<typeof trpcApi.market.getPairListFromDex.query>
>;

export const [useSearch, SearchProvider] = createStore(
  ({ onChangePair }: { onChangePair: (pairAddress: string) => void }) => {
    const [activeNetwork, setActiveNetwork] = useState<NetworkType>('all');
    const [input, setInput] = useState('');
    const [searchedList, setSearchedList] = useState<PairList>([]);
    const [isNoResult, setIsNoResult] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const hasSearchRef = useRef(false);

    useEffect(() => {
      setIsSearching(true);
    }, [input]);

    const search = useCallback((input: string) => {
      hasSearchRef.current = true;
      setSearchedList([]);
      setIsSearching(true);
      trpcApi.market.searchQuery
        .query({
          chain: 'base',
          keyword: input,
        })
        .then(data => {
          if (data.length > 0) {
            setIsNoResult(false);
            setSearchedList(data);
          } else {
            setIsNoResult(true);
          }
        })
        .catch(() => {
          setIsNoResult(true);
        })
        .finally(() => {
          setIsSearching(false);
        });
    }, []);

    return {
      activeNetwork,
      setActiveNetwork,
      networks,
      input,
      setInput,
      search,
      searchedList,
      isSearching,
      isNoResult,
      onChangePair,
    };
  },
);
